export default "__VITE_ASSET__DmISF_q2__"